import React from "react";
import { createRoot } from "react-dom/client";
import { GlobalProviders } from "./global-providers.tsx";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <GlobalProviders />
  </React.StrictMode>,
);
